import React from "react";
import { Box, Typography, Avatar, Paper, Stack, Container, Grid, Chip, Divider, AccordionDetails, AccordionSummary, Accordion } from "@mui/material";
import { Bracket, Seed, SeedItem } from "react-brackets";
import LooksOneIcon from '@mui/icons-material/LooksOne';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import Looks3Icon from '@mui/icons-material/Looks3';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MinigamesAnalysis from "./MinigamesAnalysis";

const schoolLogos = {
    "Liceum Ogólnokształcące im. Mikołaja Kopernika": "/szkoły/LO i Technikum Środa Śląska logo.png",
    "Zespół Szkół Energetycznych im. prof. Kazimierza Drewnowskiego": "/szkoły/ZSE Lublin logo.png",
    "Zespół Szkół Ogólnokształcących i Technicznych": "/szkoły/ZSOiT Jelenia Góra logo.jpeg",
    "Zespół Szkół Technicznych we Włocławku": "/szkoły/ZST Włocławek logo.webp",
    "Zespół Szkół nr 2 im. Unii Europejskiej w Rypinie": "/szkoły/ZS2 Rypin logo.jpeg",
    "Centrum Kształcenia Zawodowego i Ustawicznego w Brodnicy (ATP)": "/szkoły/CKZiU Brodnica logo.jpeg",
    "Centrum Kształcenia Zawodowego i Ustawicznego w Brodnicy": "/szkoły/CKZiU Brodnica logo.jpeg",
    "Zespół Szkół nr 1 w Wieluniu": "/szkoły/ZS1 Wieluń logo.png",
    "Technikum nr 1 im. Mikołaja Kopernika": "/szkoły/LO i Technikum Środa Śląska logo.png",
    "Zespół Szkół Zawodowych Nr. 2 im. Leona Wyczółkowskiego w Rykach": "/szkoły/ZSZ nr 2 Ryki logo.jpg",
    "ZSTE Myślenice": "/szkoły/ZSTE Myślenice logo.jpeg",
    "Zespół Szkół nr 5 im. Jana Pawła II w Lublinie": "/szkoły/ZS5 Lublin logo.jpeg",
    "ZDZ Warszawa CK w Płocku": "/szkoły/ZDZ Płock logo.jpg",
    "Zespół Szkół Rzemiosł Artystycznych im. Stanisława Wyspiańskiego w Jeleniej Górze": "/szkoły/ZSRA Jelenia Góra logo.png",
};


// const rounds = [
//     {
//         title: "1/8 Finału",
//         seeds: [
//             {
//                 id: 0, date: "2026-03-31", teams: [
//                     { name: "SP nr 1 Warszawa", score: 82, students: [{ name: "Jan Kowalski" }, { name: "Adam Nowak" }] },
//                     { name: "SP nr 24 Tarnów", score: 59, students: [{ name: "Łukasz Nowak" }, { name: "Ewa Piotrowska" }] },
//                 ]
//             },
//             {
//                 id: 1, teams: [
//                     { name: "SP nr 4 Wrocław", score: 91, students: [{ name: "Anna Lewandowska" }, { name: "Zuzia Dąbrowska" }] },
//                     { name: "SP nr 6 Poznań", score: 55, students: [{ name: "Łukasz Wiśniewski" }, { name: "Ewa Malinowska" }] },
//                 ]
//             },
//             {
//                 id: 2, teams: [
//                     { name: "SP nr 3 Gdańsk", score: 68, students: [{ name: "Piotr Mazur" }, { name: "Michał Kaczmarek" }] },
//                     { name: "SP nr 10 Gdynia", score: 58, students: [{ name: "Kacper Wiśniewski" }, { name: "Ania Kowalczyk" }] },
//                 ]
//             },
//             {
//                 id: 3, teams: [
//                     { name: "SP nr 7 Katowice", score: 70, students: [{ name: "Tomek Krajewski" }, { name: "Magda Piotrowska" }] },
//                     { name: "SP nr 8 Białystok", score: 65, students: [{ name: "Paweł Nowak" }, { name: "Kinga Zawadzka" }] },
//                 ]
//             },
//             {
//                 id: 4, teams: [
//                     { name: "SP nr 2 Kraków", score: 76, students: [{ name: "Ola Wiśniewska" }, { name: "Kasia Zielińska" }] },
//                     { name: "SP nr 16 Sopot", score: 61, students: [{ name: "Łukasz Kwiatkowski" }, { name: "Ewa Nowak" }] },
//                 ]
//             },
//             {
//                 id: 5, teams: [
//                     { name: "SP nr 11 Rzeszów", score: 62, students: [{ name: "Adam Piotrowski" }, { name: "Ola Nowak" }] },
//                     { name: "SP nr 12 Toruń", score: 54, students: [{ name: "Michał Woźniak" }, { name: "Zosia Mazur" }] },
//                 ]
//             },
//             {
//                 id: 6, teams: [
//                     { name: "SP nr 20 Łódź", score: 67, students: [{ name: "Marek Nowak" }, { name: "Julia Kowalska" }] },
//                     { name: "SP nr 21 Szczecin", score: 63, students: [{ name: "Tomasz Wiśniewski" }, { name: "Anna Malinowska" }] },
//                 ]
//             },
//             {
//                 id: 7, teams: [
//                     { name: "SP nr 13 Kielce", score: 66, students: [{ name: "Kamil Nowak" }, { name: "Ola Lewandowska" }] },
//                     { name: "SP nr 14 Olsztyn", score: 64, students: [{ name: "Paweł Kaczmarek" }, { name: "Zuzia Nowak" }] },
//                 ]
//             },
//         ],
//     },

//     {
//         title: "Ćwierćfinały",
//         seeds: [
//             {
//                 id: 8, teams: [
//                     { name: "SP nr 1 Warszawa", score: 82, students: [] },
//                     { name: "SP nr 4 Wrocław", score: 91, students: [] },
//                 ]
//             },
//             {
//                 id: 9, teams: [
//                     { name: "SP nr 3 Gdańsk", score: 68, students: [] },
//                     { name: "SP nr 7 Katowice", score: 70, students: [] },
//                 ]
//             },
//             {
//                 id: 10, teams: [
//                     { name: "SP nr 2 Kraków", score: 76, students: [] },
//                     { name: "SP nr 11 Rzeszów", score: 62, students: [] },
//                 ]
//             },
//             {
//                 id: 11, teams: [
//                     { name: "SP nr 20 Łódź", score: 67, students: [] },
//                     { name: "SP nr 13 Kielce", score: 66, students: [] },
//                 ]
//             },
//         ],
//     },

//     {
//         title: "Półfinały",
//         seeds: [
//             {
//                 id: 12, teams: [
//                     { name: "SP nr 4 Wrocław", score: 91, students: [] },
//                     { name: "SP nr 7 Katowice", score: 70, students: [] },
//                 ]
//             },
//             {
//                 id: 13, teams: [
//                     { name: "SP nr 2 Kraków", score: 76, students: [] },
//                     { name: "SP nr 20 Łódź", score: 67, students: [] },
//                 ]
//             },
//         ],
//     },

//     {
//         title: "Mecz o 3. miejsce",
//         seeds: [
//             {
//                 id: 14, teams: [
//                     { name: "SP nr 7 Katowice", score: 75, students: [] },
//                     { name: "SP nr 20 Łódź", score: 72, students: [] },
//                 ]
//             },
//         ],
//     },

//     {
//         title: "Finał",
//         seeds: [
//             {
//                 id: 15, teams: [
//                     { name: "SP nr 4 Wrocław", score: 95, students: [] },
//                     { name: "SP nr 2 Kraków", score: 88, students: [] },
//                 ]
//             },
//         ],
//     },
// ];


// const qualifyingTeams = [
//     { name: "SP nr 1 Warszawa", score: 82, students: [{ name: "Jan Kowalski" }, { name: "Adam Nowak" }] },
//     { name: "SP nr 2 Kraków", score: 76, students: [{ name: "Ola Wiśniewska" }, { name: "Kasia Zielińska" }] },
//     { name: "SP nr 3 Gdańsk", score: 68, students: [{ name: "Piotr Mazur" }, { name: "Michał Kaczmarek" }] },
//     { name: "SP nr 4 Wrocław", score: 91, students: [{ name: "Anna Lewandowska" }, { name: "Zuzia Dąbrowska" }] },
//     { name: "SP nr 5 Lublin", score: 60, students: [{ name: "Karol Nowicki" }, { name: "Marta Szymańska" }] },
//     { name: "SP nr 6 Poznań", score: 55, students: [{ name: "Łukasz Wiśniewski" }, { name: "Ewa Malinowska" }] },
//     { name: "SP nr 7 Katowice", score: 70, students: [{ name: "Tomek Krajewski" }, { name: "Magda Piotrowska" }] },
//     { name: "SP nr 8 Białystok", score: 65, students: [{ name: "Paweł Nowak" }, { name: "Kinga Zawadzka" }] },
//     { name: "SP nr 9 Radom", score: 50, students: [{ name: "Piotr Zieliński" }, { name: "Marta Lewandowska" }] },
//     { name: "SP nr 10 Gdynia", score: 58, students: [{ name: "Kacper Wiśniewski" }, { name: "Ania Kowalczyk" }] },
//     { name: "SP nr 11 Rzeszów", score: 62, students: [{ name: "Adam Piotrowski" }, { name: "Ola Nowak" }] },
//     { name: "SP nr 12 Toruń", score: 54, students: [{ name: "Michał Woźniak" }, { name: "Zosia Mazur" }] },
//     { name: "SP nr 13 Łódź", score: 48, students: [{ name: "Piotr Kaczmarek" }, { name: "Magda Nowicka" }] },
//     { name: "SP nr 14 Opole", score: 45, students: [{ name: "Tomek Lewandowski" }, { name: "Ania Wiśniewska" }] },
//     { name: "SP nr 15 Koszalin", score: 52, students: [{ name: "Karol Piotrowski" }, { name: "Marta Zielińska" }] }
// ];


const qualifyingTeams = [
    {
        name: "Liceum Ogólnokształcące im. Mikołaja Kopernika",
        score: 42.77,
        students: [
            { name: "Oskar Maciejewski" },
            { name: "Oskar Polatowski" },
            { name: "Michał Strzałkowski" },
            { name: "Kaja Maciejewska" },
            { name: "Emilia Żołnierczyk" },
            { name: "Wiktoria Mazur" },
            { name: "Julia Kosmala" }
        ]
    },
    {
        name: "Zespół Szkół Energetycznych im. prof. Kazimierza Drewnowskiego",
        score: 40.62,
        students: [
            { name: "Aleksandra Padzińska" },
            { name: "Sofia Bubyr" },
            { name: "Wiktor Depta" },
            { name: "Mateusz Kańczugowski" },
            { name: "Aleksander Wilczyński" },
            { name: "Jakub Matoszka" },
            { name: "Michał Kubiś" },
            { name: "Bruno Czekirda" }
        ]
    },
    {
        name: "Zespół Szkół Technicznych we Włocławku",
        score: 38.92,
        students: [
            { name: "Piotr Balcerowski" },
            { name: "Szymon Ludwicki" },
            { name: "Filip Podolski" },
            { name: "Wojciech Kruszyna" },
            { name: "Witold Leśnik" },
            { name: "Jakub Bochiński" },
            { name: "Dawid Sporek" }
        ]
    },
    {
        name: "Zespół Szkół nr 2 im. Unii Europejskiej w Rypinie",
        score: 37.62,
        students: [
            { name: "Kamil Żebrowski" },
            { name: "Konrad Żuchowski" },
            { name: "Kacper Rakowski" },
            { name: "Dominik Urbański" },
            { name: "Kacper Kleps" },
            { name: "Marek Felka" },
            { name: "Julian Liszewski" },
            { name: "Dawid Kisielewski" }
        ]
    },
    {
        name: "Zespół Szkół Ogólnokształcących i Technicznych",
        score: 35.62,
        students: [
            { name: "Wiktor Woźny" },
            { name: "Stanisław Drobiazko" },
            { name: "Kacper Kędziorek" },
            { name: "Bartłomiej Warzocha" },
            { name: "Błażej Sochowicz" },
            { name: "Igor Śliwa" },
            { name: "Martyna Rogalska" },
            { name: "Nadia Szymczyk" }
        ]
    },
    {
        name: "Zespół Szkół Zawodowych Nr. 2 im. Leona Wyczółkowskiego w Rykach",
        score: 25.54,
        students: [
            { name: "Daniel Waszczuk-Kubis" },
            { name: "Michał Bakiera" },
            { name: "Stanisław Kwas" },
            { name: "Gabriel Bieńczyk" },
            { name: "Dominik Miłosz" },
            { name: "Mikhailo Drozd" },
            { name: "Grzegorz Nosowski" },
            { name: "Filip Kalbarz" }
        ]
    },

    {
        name: "Centrum Kształcenia Zawodowego i Ustawicznego w Brodnicy (ATP)",
        score: 28.62,
        students: [
            { name: "Marcin Boniecki" },
            { name: "Krystian Piórkowski" },
            { name: "Oskar Samek" },
            { name: "Przemysław Ozimkowski" },
            { name: "Filip Lewandowski" },
            { name: "Dawid Pilewski" },
            { name: "Adam Marchlewski" },
            { name: "Piotr Cześnik" }
        ]
    },
    {
        name: "ZSTE Myślenice",
        score: 24.31,
        students: [
            { name: "Szymon Kania" },
            { name: "Jerzy Rachwał" },
            { name: "Wojciech Ziaja" },
            { name: "Kacper Chrzanowski" },
            { name: "Patryk Skałka" },
            { name: "Wojciech Marcisz" },
            { name: "Adam Gościej" },
            { name: "Piotr Ziaja" }
        ]
    },
    {
        name: "Technikum nr 1 im. Mikołaja Kopernika",
        score: 21.92,
        students: [
            { name: "Lena Stachowicz" },
            { name: "Mateusz Żmuda" },
            { name: "Błażej Niedzielski" },
            { name: "Bartosz Plich" },
            { name: "Aleksandra Nowak" },
            { name: "Martyna Czarniecka" },
            { name: "Aleksandra Mielczarek" }
        ]
    },
    {
        name: "Zespół Szkół nr 1 w Wieluniu",
        score: 19.46,
        students: [
            { name: "Wojtynek Marcel" },
            { name: "Jakub Ścigała" },
            { name: "Mikołaj Nowak" },
            { name: "Dominik Byczak" }
        ]
    },
    {
        name: "Zespół Szkół nr 5 im. Jana Pawła II w Lublinie",
        score: 17.46,
        students: [
            { name: "Fabian Grudzień" },
            { name: "Dorian Poniatowski" },
            { name: "Julian Kwiatosz" },
            { name: "Ksawery Tymecki" },
            { name: "Daniel Szwedo" },
            { name: "Mateusz Ostrowski" },
            { name: "Łukasz Walkowski" }
        ]
    },
    {
        name: "Centrum Kształcenia Zawodowego i Ustawicznego w Brodnicy",
        score: 13.46,
        students: [
            { name: "Małgorzata Liwicka" },
            { name: "Oliwia Olszewska" },
            { name: "Oliwia Sikorska" },
            { name: "Jakub Burszta" },
            { name: "Antoni Kwiatkowski" },
            { name: "Wiktor Kokoszanek" },
            { name: "Aleksander Bajorek" },
            { name: "Marcel Wenderholm" }
        ]
    },
    {
        name: "ZDZ Warszawa CK w Płocku",
        score: 4.15,
        students: [
            { name: "Julia Bąk" },
            { name: "Łukasz Michalski" },
            { name: "Jakub Wiącek" },
            { name: "Wiktor Żochowski" },
            { name: "Gabriel Brokowski" },
            { name: "Filip Pluciak" },
            { name: "Hubert Pietruszka" },
            { name: "Igor Chmielewski" }
        ]
    },
    {
        name: "Zespół Szkół Rzemiosł Artystycznych im. Stanisława Wyspiańskiego w Jeleniej Górze",
        score: 3.15,
        students: [
            { name: "Jakub Popczyk" },
            { name: "Laura Brzozowska" },
            { name: "Antoni Brzostowski" },
            { name: "Michalina Krzechka" },
            { name: "Anastasiia Piz" },
            { name: "Jakub Zarówny" },
            { name: "Zofia Kozik" },
            { name: "Szymon Gąsior" }
        ]
    }
];

const sortedTeams = [...qualifyingTeams].sort((a, b) => b.score - a.score);

// const CustomSeed = ({ seed, breakpoint, roundIndex, totalRounds }) => {

//     const baseWidth = 230;
//     const baseHeight = 60;

//     const effectiveIndex = Math.min(roundIndex, 1)

//     const width = baseWidth - effectiveIndex * 40;
//     const height = baseHeight + roundIndex * 10;

//     return (
//         <Seed mobileBreakpoint={breakpoint}>
//             <SeedItem style={{ background: "transparent", width: width }}>
//                 <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
//                     {seed.teams.map((team, index) => (
//                         <div
//                             key={team.name}
//                             style={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 background: index === 0 ? "#294e6b" : "#58656252",
//                                 padding: "4px 8px",
//                                 borderRadius: 4,
//                                 gap: 8,
//                                 height: height
//                             }}
//                         >
//                             <img
//                                 src={schoolLogos[team.name]}
//                                 alt={team.name}
//                                 style={{ width: 30, height: 30, borderRadius: "50%" }}
//                             />
//                             <div style={{ display: "flex", flexDirection: "column" }}>
//                                 <span style={{ fontWeight: "bold" }}>{team.name}</span>
//                                 <span style={{ fontSize: 10 }}>
//                                     {team.students.map((s) => s.name).join(", ")}
//                                 </span>
//                             </div>
//                             <span style={{ marginLeft: "auto", fontWeight: "bold" }}>{team.score}</span>
//                             {roundIndex === totalRounds - 1 && index === 0 && (
//                                 <img
//                                     src="/crown.svg"
//                                     alt="Zwycięzca"
//                                     style={{
//                                         width: 24,
//                                         height: 24,
//                                         position: "absolute",
//                                         top: -8,
//                                         right: -8,
//                                     }}
//                                 />
//                             )}
//                         </div>
//                     ))}
//                 </div>
//             </SeedItem>
//         </Seed>
//     )
// };

const VrCup = () => {
    return (
        // <Box sx={{ p: 3, backgroundColor: "#fafafa", minHeight: "100vh" }}>
        //     {/* <Typography
        //         variant="h4"
        //         sx={{ mb: 3, textAlign: "center", fontWeight: "bold", color: "#1976d2" }}
        //     >
        //         VR Cup 2026
        //     </Typography> */}
        //     <img
        //         // src={`${process.env.REACT_APP_MEDIA_URL}/vr-cup.png`}
        //         src={`/vr-cup.png`}
        //         alt="badge"
        //         style={{ width: "100px", marginLeft: 20, textAlign: "center", display: "block", margin: "0 auto 20px" }}
        //     />

        //     <Box sx={{ display: "flex", gap: 4, textAlign: "center", justifyContent: "center" }}>
        //         <Box sx={{ width: "450px", backgroundColor: "#6cc4dc", p: 2, borderRadius: 2 }}>
        //             <Typography
        //                 variant="h5"
        //                 sx={{
        //                     textAlign: "center",
        //                     color: "#294e6b",
        //                     fontWeight: "bold",
        //                     mb: 2,
        //                 }}
        //             >
        //                 Kwalifikacje
        //             </Typography>
        //             {/* {qualifyingTeams.map((team, index) => ( */}
        //             {sortedTeams.map((team, index) => (
        //                 <div style={{ display: "flex", flexDirection: "column", gap: 4, marginTop: 5 }}>
        //                     <div
        //                         key={team.name}
        //                         style={{
        //                             display: "flex",
        //                             alignItems: "center",
        //                             background: index < qualifyingTeams.length / 2 ? "#294e6b" : "#58656252",
        //                             padding: "4px 8px",
        //                             borderRadius: 4,
        //                             gap: 8,
        //                         }}
        //                     >
        //                         <img
        //                             src={schoolLogos[team.name]}
        //                             alt={team.name}
        //                             style={{ width: 30, height: 30, borderRadius: "50%" }}
        //                         />
        //                         <div style={{ display: "flex", flexDirection: "column" }}>
        //                             <span style={{ fontWeight: "bold" }}>{team.name}</span>
        //                             <span style={{ fontSize: 10 }}>
        //                                 {team.students.map((s) => s.name).join(", ")}
        //                             </span>
        //                         </div>
        //                         <span style={{ marginLeft: "auto", fontWeight: "bold" }}>{team.score}</span>
        //                     </div>

        //                 </div>
        //                 // <Stack key={team.name} direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
        //                 //     <Avatar src={schoolLogos[team.name]} alt={team.name} sx={{ width: 30, height: 30 }} />
        //                 //     <Stack>
        //                 //         <Typography variant="body2" sx={{ fontWeight: "bold" }}>
        //                 //             {team.name}
        //                 //         </Typography>
        //                 //         <Typography variant="caption">{team.students.join(", ")}</Typography>
        //                 //     </Stack>
        //                 //     <Typography sx={{ ml: "auto", fontWeight: "bold" }}>{team.score}</Typography>
        //                 // </Stack>
        //             ))}
        //         </Box>

        //         <Box sx={{ flexGrow: 1 }}>

        //             <Bracket
        //                 rounds={rounds}
        //                 renderSeedComponent={CustomSeed}
        //                 roundTitleComponent={(title) => (
        //                     <Typography
        //                         variant="h5"
        //                         sx={{
        //                             textAlign: "center",
        //                             color: "#294e6b",
        //                             fontWeight: "bold",
        //                             mb: 2,
        //                         }}
        //                     >
        //                         {title}
        //                     </Typography>
        //                 )}
        //             />
        //         </Box>
        //     </Box>
        // </Box>

        <Container sx={{ py: 4 }}>
            <Grid container spacing={4} alignItems="flex-start" justifyContent="center">
                <Grid item xs={12} md={12}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 2,
                            py: 3,
                        }}
                    >
                        <Typography
                            variant="h4"
                            sx={{
                                fontWeight: 300,
                                color: "#294e6b",
                                textTransform: "uppercase",
                                letterSpacing: 1,
                            }}
                        >
                            Ranking
                        </Typography>

                        <Box
                            component="img"
                            src="/vrcup/logo.png"
                            alt="VR Cup Logo"
                            sx={{
                                width: 120,
                                filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.15))",
                            }}
                        />

                        <Typography
                            variant="h4"
                            sx={{
                                fontWeight: 300,
                                color: "#294e6b",
                                textTransform: "uppercase",
                                letterSpacing: 1,
                            }}
                        >
                            Końcowy
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
                    <Box sx={{ width: "100%", maxWidth: 900, mx: "auto" }}>


                        {sortedTeams.map((team, index) => {
                            // const podiumColors = {
                            //     0: "#FFD700",
                            //     1: "#C0C0C0",
                            //     2: "#CD7F32",
                            // };

                            const podiumColors = {
                                0: "linear-gradient(135deg, #FFF8DC 0%, #FFD700 35%, #FFC107 65%, #B8860B 100%)",
                                1: "linear-gradient(135deg, #FFFFFF 0%, #E8E8E8 25%, #C0C0C0 60%, #7A7A7A 100%)",
                                2: "linear-gradient(135deg, #F4A460 0%, #CD7F32 35%, #A0522D 70%, #6F4E37 100%)",
                            };

                            return (
                                <Paper
                                    key={team.name}
                                    elevation={index < 3 ? 8 : 1}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        p: 2,
                                        mb: 1.5,
                                        borderRadius: 3,

                                        backgroundImage:
                                            podiumColors[index] ??
                                            "linear-gradient(135deg, #294e6b 0%, #1f3d54 100%)",

                                        backgroundColor: "transparent",
                                        color: index < 3 ? "#111" : "#fff",

                                        position: "relative",
                                        overflow: "hidden",

                                        transition: "all .2s ease",
                                        "&:hover": {
                                            transform: "translateY(-2px)",
                                            boxShadow: 8,
                                        },
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: 70,
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            flexShrink: 0,
                                        }}
                                    >
                                        {index === 0 ? (
                                            <LooksOneIcon
                                                fontSize="large"
                                                sx={{
                                                    color: "#FFD700",
                                                    filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.3))",
                                                }}
                                            />
                                        ) : index === 1 ? (
                                            <LooksTwoIcon
                                                fontSize="large"
                                                sx={{
                                                    color: "#C0C0C0",
                                                    filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.3))",
                                                }}
                                            />
                                        ) : index === 2 ? (
                                            <Looks3Icon
                                                fontSize="large"
                                                sx={{
                                                    color: "#CD7F32",
                                                    filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.3))",
                                                }}
                                            />
                                        ) : (
                                            <Typography
                                                sx={{
                                                    fontWeight: 700,
                                                    color: "#294e6b",
                                                    fontSize: 24,
                                                }}
                                            >
                                                #{index + 1}
                                            </Typography>
                                        )}
                                    </Box>

                                    <Avatar
                                        src={schoolLogos[team.name]}
                                        sx={{ width: 50, height: 50, mx: 2 }}
                                    />

                                    <Box sx={{ flexGrow: 1 }}>
                                        <Typography fontWeight="bold">
                                            {team.name}
                                        </Typography>

                                        <Typography variant="caption">
                                            {team.students.map((s) => s.name).join(", ")}
                                        </Typography>
                                    </Box>

                                    <Typography
                                        sx={{
                                            fontSize: 24,
                                            fontWeight: "bold",
                                        }}
                                    >
                                        {team.score}
                                    </Typography>
                                </Paper>
                            );
                        })}
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Paper
                                elevation={0}
                                sx={{
                                    p: 3,
                                    borderRadius: 4,
                                    border: "1px solid",
                                    borderColor: "rgba(0,0,0,0.08)",
                                    backgroundImage:
                                        "linear-gradient(135deg, #FFF8DC 0%, #FFD700 35%, #FFC107 65%, #B8860B 100%)",
                                    position: "relative",
                                    overflow: "hidden",
                                    minHeight: 220,
                                }}
                            >
                                <EmojiEventsIcon
                                    sx={{
                                        position: "absolute",
                                        right: -40,
                                        top: "50%",
                                        transform: "translateY(-50%) rotate(-12deg)",
                                        fontSize: 180,
                                        opacity: 0.18,
                                        color: "#6b4e00",
                                        filter: "drop-shadow(0 10px 20px rgba(0,0,0,0.25))",
                                        pointerEvents: "none",
                                    }}
                                />

                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        mb: 3,
                                        position: "relative",
                                        zIndex: 1,
                                    }}
                                >
                                    <Typography
                                        variant="overline"
                                        sx={{
                                            fontWeight: 800,
                                            letterSpacing: 2,
                                            color: "rgba(0,0,0,0.65)",
                                        }}
                                    >
                                        MVP TURNIEJU
                                    </Typography>

                                    <EmojiEventsIcon
                                        sx={{
                                            color: "#7a5200",
                                            fontSize: 28,
                                            filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.25))",
                                        }}
                                    />
                                </Box>

                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 2,
                                        position: "relative",
                                        zIndex: 1,
                                    }}
                                >
                                    <Avatar
                                        src="/vrcup/mvp.png"
                                        sx={{
                                            width: 88,
                                            height: 88,
                                            border: "3px solid rgba(255,255,255,0.6)",
                                            boxShadow: "0 8px 20px rgba(0,0,0,0.25)",
                                        }}
                                    />

                                    <Box flex={1}>
                                        <Typography
                                            variant="h5"
                                            sx={{
                                                fontWeight: 800,
                                                lineHeight: 1.1,
                                                color: "#2d1f00",
                                            }}
                                        >
                                            Kacper Kleps
                                        </Typography>

                                        <Typography
                                            variant="body2"
                                            sx={{
                                                mt: 0.5,
                                                color: "rgba(0,0,0,0.65)",
                                            }}
                                        >
                                            Zespół Szkół nr 2 im. Unii Europejskiej w Rypinie
                                        </Typography>
                                    </Box>
                                </Box>

                                <Divider sx={{ my: 3, borderColor: "rgba(0,0,0,0.15)" }} />

                                <Stack
                                    direction="row"
                                    spacing={1}
                                    flexWrap="wrap"
                                    useFlexGap
                                    sx={{ position: "relative", zIndex: 1 }}
                                >
                                    <Chip
                                        icon={<EmojiEventsIcon />}
                                        label="MVP"
                                        sx={{
                                            backgroundColor: "rgba(255,255,255,0.35)",
                                            fontWeight: 700,
                                        }}
                                    />

                                    <Chip
                                        label="553 pkt"
                                        sx={{
                                            backgroundColor: "rgba(255,255,255,0.25)",
                                        }}
                                    />

                                    <Chip
                                        label="Miejsce drużyny 4"
                                        sx={{
                                            backgroundColor: "rgba(255,255,255,0.25)",
                                        }}
                                    />
                                </Stack>
                            </Paper>
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <MinigamesAnalysis />
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>
        </Container>
    );
};

export default VrCup;